import type { ReactNode } from "react";

import { Button } from "@/components/ui/button.tsx";

/** One of a row's small action buttons. */
export const RowButton = ({
  label,
  ariaLabel,
  icon,
  statsigName,
  onClick,
  disabled,
}: {
  label: string;
  /** Drawn instead of the words. `label` still names it for a screen reader. */
  icon?: ReactNode;
  /** When several rows carry the same verb, to say which one this acts on. */
  ariaLabel?: string;
  statsigName: string;
  onClick: () => void;
  disabled: boolean;
}) => (
  <Button
    type="button"
    variant="outline"
    size="sm"
    // Opaque, so a button on a card drawn at part strength still reads as a
    // control rather than as something disabled.
    className="h-7 bg-white px-2 text-xs"
    aria-label={ariaLabel ?? (icon ? label : undefined)}
    data-statsig-name={statsigName}
    disabled={disabled}
    onClick={onClick}
  >
    {icon ?? label}
  </Button>
);
